import { useEffect } from "react";

const PageMeta = ({ title, description }) => {
  useEffect(() => {
    const previousTitle = document.title;
    const metaDescription = document.querySelector('meta[name="description"]');
    const previousDescription = metaDescription?.getAttribute("content");

    if (title) {
      document.title = title;
    }

    if (metaDescription && description) {
      metaDescription.setAttribute("content", description);
    }

    return () => {
      document.title = previousTitle;

      if (metaDescription && previousDescription) {
        metaDescription.setAttribute("content", previousDescription);
      }
    };
  }, [title, description]);

  return null;
};

export default PageMeta;
